// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"f2d97441","124":"f728190f","315":"ad8ed1ab","416":"ca75c784","610":"c9d28c11"}[chunkId] + ".chunk.css";
};